'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface HoverContextType {
  isHovering: boolean
  setIsHovering: (value: boolean) => void
}

const HoverContext = createContext<HoverContextType | undefined>(undefined)

export const HoverProvider = ({ children }: { children: ReactNode }) => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <HoverContext.Provider value={{ isHovering, setIsHovering }}>
      {children}
    </HoverContext.Provider>
  )
}

export const useHover = () => {
  const context = useContext(HoverContext)
  if (!context) {
    throw new Error('useHover must be used within HoverProvider')
  }
  return context
}
